import {ALookupRowsContainer} from "./lookup.rows.container";
import {PpsItemExtra} from "./pps.item.extra";

export class PpsItem extends ALookupRowsContainer {
	ppsItemKey: number;
	ppsKey: number;
	procedureCodeKey: number;
	lateralityKey: number;
	sequenceId: number;
	modifierCodeKey: number;
	ppsItemExtra: PpsItemExtra[];

	// public SetData(procedureCode: IProcedureCode, sequenceId: number){
	// 	this.procedureCodeKey = procedureCode.procedureCodeKey;
	// 	this.lateralityKey = procedureCode.lateralityKeys;
	// 	this.sequenceId = sequenceId;
	//
	// 	this.FKLookupRows = {procedureCodeKey: procedureCode};
	// }
}
